import React from 'react';

import FieldHelpIcon from 'components/FieldHelpIcon';

import { FieldDescription, RequiredAsterisk, SectionGrid } from './styles';

const EditEntityRow: React.FC<{
  name: string;
  children: React.ReactNode;
  id?: string;
  helpText?: string | null;
  required?: boolean;
  inputTestId?: string;
}> = ({ name, children, id, helpText, required, inputTestId }): React.ReactElement => (
  <>
    <SectionGrid container item xs={12} alignContent="flex-start" id={id}>
      <FieldDescription>
        {name}
        {required && <RequiredAsterisk>*</RequiredAsterisk>}
        {helpText && <FieldHelpIcon name={name} helpText={helpText} />}
      </FieldDescription>
    </SectionGrid>
    <SectionGrid container item xs={12} data-testid={inputTestId}>
      {children}
    </SectionGrid>
  </>
);

export default EditEntityRow;
